import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsx mdx */

import { Boids, ChillBoids } from '../../components/examples/';
export const _frontmatter = {
  "Title": "Boids"
};

const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};

const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">

    <h1 {...{
      "id": "boids"
    }}>{`Boids`}</h1>
    <Boids mdxType="Boids" />
    <p><a parentName="p" {...{
        "href": "https://en.wikipedia.org/wiki/Boids"
      }}>{`Boids`}</a>{` is one of the best-known agent simulations in computer graphics.`}</p>
    <p>{`A number of boid agents move in a plane and their movement is governed by three forces:`}</p>
    <ul>
      <li parentName="ul">{`alignment: they try to move in the same direction than the boids around them,`}</li>
      <li parentName="ul">{`cohesion: they try to move towards the average position of boids around them,`}</li>
      <li parentName="ul">{`separation: they try to avoid other boids around them.`}</li>
    </ul>
    <p>{`The boids movement is reminescent of that of flock of birds.`}</p>
    <p>{`In our implementation, each of these forces can be parameterized: the coefficient is how much this force affects the boid's movement, and the radius is the maximum distance at which neighboring boids are considered.`}</p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      